import React from 'react';

/**
 * Content for the BDD "Other medical records" page
 * (supporting-evidence/other-medical-records-bdd). Copy matches the V2 Figma design.
 */
export const otherMedicalRecordsBddQuestion = {
  label: 'Are there other medical records that you’d like us to review?',
  labels: {
    Y: 'Yes',
    N: 'No',
  },
};

export const OtherMedicalRecordsBddDescription = () => (
  <>
    <p>
      You can submit medical records from any of these healthcare providers:
    </p>
    <ul>
      <li>Private healthcare providers (non-VA)</li>
      <li>Veteran’s Choice</li>
      <li>Vet Centers</li>
      <li>Community care providers</li>
    </ul>
    <p>
      <strong>Note:</strong> We’ll need your permission to request access to
      your medical records from these healthcare providers. Or you can upload
      copies of your medical records.
    </p>
  </>
);
